import React from 'react';
import MayoralReports from './components/MayoralReports';
import Log from './components/Log';
import LegislativeRaces from './components/LegislativeRaces';
import LegFullYearReports from './components/LegFullYearReports';
import PacReports from './components/PacReports';
import LpcReports from './components/LpcReports';
import StatewideReports from './components/StatewideReports';
import CountyReports from './components/CountyReports';
import CityCouncilReports from './components/CityCouncilReports';
import StatePartyReports from './components/StatePartyReports';
import BallotQuestionReports from './components/BallotQuestionReports';
import ActiveBallotQuestionReports from './components/ActiveBallotQuestionReports';
import DisplayReport from './components/DisplayReport';
import SegregatedFunds from './components/SegregatedFunds';
import SpecialElections from './components/SpecialElections';
import IndependentExpenditurePacReports from './components/IndependentExpenditurePacReports';
import IndependentExpendituresReports from './components/IndependentExpendituresReports';
import BallotQuestionSpendingReports from './components/Cpf22s';
import ElectioneeringCommunicationsReports from './components/ElectioneeringCommunicationsReports';
import CasinoBallotQuestionSpending from './components/CasinoBallotQuestionSpending';
import GroupPoliticalSpending from './components/GroupPoliticalSpending';
import IepacYearEndReports from './components/IepacYearEndReports';

const routes = [
  {
    path: '/Reports/MayoralReports',
    renderer: (params = {}): JSX.Element => <MayoralReports {...params} />,
  },
  {
    path: '/Reports/Log',
    renderer: (params = {}): JSX.Element => <Log {...params} />,
  },
  {
    path: '/Reports/LegislativeRaces',
    renderer: (params = {}): JSX.Element => <LegislativeRaces {...params} />,
  },
  {
    path: '/Reports/LegFullYearReports',
    renderer: (params = {}): JSX.Element => <LegFullYearReports {...params} />,
  },
  {
    path: '/Reports/StatewideReports',
    renderer: (params = {}): JSX.Element => <StatewideReports {...params} />,
  },
  {
    path: '/Reports/PacReports',
    renderer: (params = {}): JSX.Element => <PacReports {...params} />,
  },
  {
    path: '/Reports/LpcReports',
    renderer: (params = {}): JSX.Element => <LpcReports {...params} />,
  },
  {
    path: '/Reports/StatePartyReports',
    renderer: (params = {}): JSX.Element => <StatePartyReports {...params} />,
  },
  {
    path: '/Reports/CountyReports',
    renderer: (params = {}): JSX.Element => <CountyReports {...params} />,
  },
  {
    path: '/Reports/CityCouncilReports',
    renderer: (params = {}): JSX.Element => <CityCouncilReports {...params} />,
  },
  {
    path: '/Reports/BallotQuestionReports',
    renderer: (params = {}): JSX.Element => <BallotQuestionReports {...params} />,
  },
  {
    path: '/Reports/ActiveBallotQuestionReports',
    renderer: (params = {}): JSX.Element => <ActiveBallotQuestionReports {...params} />,
  },
  {
    path: '/Reports/Segregatedfunds',
    renderer: (params = {}): JSX.Element => <SegregatedFunds {...params} />,
  },
  {
    path: '/Reports/Specialelections',
    renderer: (params = {}): JSX.Element => <SpecialElections {...params} />,
  },
  {
    path: '/filers/specialelections',
    renderer: (params = {}): JSX.Element => <SpecialElections {...params} />,
  },
  {
    path: '/Reports/IndependentExpenditurePacReports',
    renderer: (params = {}): JSX.Element => <IndependentExpenditurePacReports {...params} />,
  },
  {
    path: '/Reports/IndependentExpenditures',
    renderer: (params = {}): JSX.Element => <IndependentExpendituresReports {...params} />,
  },
  {
    path: '/Reports/BallotQuestionSpendingReports',
    renderer: (params = {}): JSX.Element => <BallotQuestionSpendingReports {...params} />,
  },
  {
    path: '/Reports/Cpf22s',
    renderer: (params = {}): JSX.Element => <BallotQuestionSpendingReports {...params} />,
  },
  {
    path: '/Reports/ElectioneeringCommunications',
    renderer: (params = {}): JSX.Element => <ElectioneeringCommunicationsReports {...params} />,
  },
  {
    path: '/Reports/CasinoBallotQuestionSpending',
    renderer: (params = {}): JSX.Element => <CasinoBallotQuestionSpending {...params} />,
  },
  {
    path: '/Reports/GroupPoliticalSpending',
    renderer: (params = {}): JSX.Element => <GroupPoliticalSpending {...params} />,
  },
  {
    path: '/Reports/IepacYearEndReports',
    renderer: (params = {}): JSX.Element => <IepacYearEndReports {...params} />,
  },
  {
    path: '/Reports/displayReport',
    renderer: (params = {}): JSX.Element => <DisplayReport {...params} />,
  },
];

export default routes;
